// @copyright  2006-2024 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: '/:organisation/inventory/inventory-categories',
        component: () =>
            import('@/pages/[organisation]/inventory/inventory-categories.vue'),
        name: 'inventory.inventory-categories.search-inventory-categories',
        meta: {
            loginRequired: true,
            permission: 'access.inventory.inventory-categories.view-inventory-categories',
        },

        children: [
            {
                path: 'new',
                component: () =>
                    import('@/pages/[organisation]/inventory/inventory-categories/new.vue'),
                name: 'inventory.inventory-categories.create-inventory-category',
                meta: {
                    loginRequired: true,
                    permission: 'access.inventory.inventory-categories.create-inventory-category',
                },
            },
            {
                path: ':id',
                component: () =>
                    import('@/pages/[organisation]/inventory/inventory-categories/[id].vue'),
                name: 'inventory.inventory-categories.view-inventory-category',
                meta: {
                    loginRequired: true,
                    permission: 'access.inventory.inventory-categories.view-inventory-categories',
                },
            },
            {
                path: ':id/edit',
                component: () =>
                    import('@/pages/[organisation]/inventory/inventory-categories/[id]/edit.vue'),
                name: 'inventory.inventory-categories.update-inventory-category',
                meta: {
                    loginRequired: true,
                    permission: 'access.inventory.inventory-categories.update-inventory-category',
                },
            },
        ],
    },
];
